import api from './api';

export const dashboardService = {
    getMatriculaKanban: async (anioLectivoId = null) => {
        try {
            const params = anioLectivoId ? { anio_lectivo_id: anioLectivoId } : {};
            const response = await api.get('/kanban/matriculas', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching kanban data:', error);
            throw error;
        }
    }
};
